module.exports = __webpack_public_path__ + "img/00032.e0c69e19.webp";